export default __webpack_public_path__ + "static/DSC_0440-32c8ef289018b28dacc26299ff6d3105.jpg";